"use client";

import { useEffect } from "react";

/**
 * Locks body scroll when a modal/overlay is open.
 * Preserves scroll position and restores it on unlock.
 * Uses position:fixed approach for iOS Safari compatibility.
 */
export function useBodyScrollLock(isLocked: boolean) {
  useEffect(() => {
    if (!isLocked) return;

    const scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";

    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      window.scrollTo(0, scrollY);
    };
  }, [isLocked]);
}
